import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import Lightbox from 'react-images'
import { Button } from 'reactstrap'
import {
  pi_cost_planning_pdf,
  pi_cost_planning_video,
  pi_cost_planning_images,
  pi_revenue_planning_pdf,
  pi_revenue_planning_video,
  pi_revenue_planning_images,
  pi_overview_pdf,
  pi_overview_video,
  pi_overview_images,
} from '../../../static/images/manual'
import { SearchSelect } from '../../input'

const options = [
  { label: 'Overview', value: 2 },
  { label: 'Cost Planning', value: 0 },
  { label: 'Revenue Planning', value: 1 },
]

const theme = {
// thumbnails
  thumbnail__active: {
    boxShadow: '0 0 0 2px #00D8FF',
  },
}

export default class Manual extends React.Component {
  state={ currentImage: 0 }

  getImages = type => {
    switch (type) {
      case 1: return pi_revenue_planning_images
      case 2: return pi_overview_images
      default: return pi_cost_planning_images
    }
  }

  getVideo = type => {
    switch (type) {
      case 1: return pi_revenue_planning_video
      case 2: return pi_overview_video
      default: return pi_cost_planning_video
    }
  }

  getPDF = type => {
    switch (type) {
      case 1: return pi_revenue_planning_pdf
      case 2: return pi_overview_pdf
      default: return pi_cost_planning_pdf
    }
  }

  handleClickImage = () => {
    if (this.state.currentImage === this.getImages(this.props.typeManual).length - 1) return
    this.gotoNext()
  }

  gotoImage = (index) => {
    this.setState({ currentImage: index })
  }

  gotoNext = () => {
    this.setState({ currentImage: this.state.currentImage + 1 })
  }

  gotoPrevious = () => {
    this.setState({ currentImage: this.state.currentImage - 1 })
  }

  closeImage = () => {
    this.setState({
      currentImage: 0,
      isOpen: false,
    })
    this.props.closeManual()
  }

  handleDropdown = e => {
    this.props.setTypeManual(e.value)
    this.setState({ currentImage: 0 })
  }
  render() {
    const { typeManual } = this.props
    const download = (
      <ButtonGroup>
        <DropdownWrapper>
          <SearchSelect
            options={ options }
            value={ options.find(o => o.value === typeManual) }
            onChange={ this.handleDropdown }
          />
        </DropdownWrapper>
        <PDFButton
          onClick={ () => window.open(this.getPDF(typeManual), '_blank') }
        >PDF
        </PDFButton>
        { this.props.typeManual !== 2 &&
        <VideoButton
          onClick={ () => window.open(this.getVideo(typeManual), '_blank') }
        >Video Tutorial
        </VideoButton>
        }
      </ButtonGroup>
    )

    return (
      <Lightbox
        images={ this.getImages(typeManual) }
        backdropClosesModal={ true }
        enableKeyboardInput={ true }
        showThumbnails={ true }
        currentImage={ this.state.currentImage }
        isOpen={ get(this.props, 'isOpen', false) }
        onClickPrev={ this.gotoPrevious }
        onClickNext={ this.gotoNext }
        onClickImage={ this.handleClickImage }
        onClickThumbnail={ this.gotoImage }
        onClose={ this.closeImage }
        theme={ theme }
        customControls={ [download] }
      />
    )
  }
}

Manual.propTypes = {
  closeManual: PropTypes.func,
  typeManual: PropTypes.number,
}
Manual.defaultProps = {
  closeManual: () => {},
  typeManual: 0,
}

const PDFButton = styled(Button)`
  width: 80px;
  height: 30px;
  font-size: 12px;
  font-family: Gotham;
  color: white;
  background-color: #428BCA;
`

const VideoButton = styled(PDFButton)`
  width: 130px;
  margin-left: 8px;
`

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
`

const DropdownWrapper = styled.div`
  width: 200px;
  margin-right: 8px;
`



// WEBPACK FOOTER //
// ./src/components/project-information/helper/manual.js